@if (communicationChannelConfigService.isCommunicationChannelEnabled()) {
  <div class="nav-menu dark">
    <ul class="navbar-nav">
      @if (communicationChannelConfigService.isCommunicationChannelInformationEnabled()) {
        <li class="nav-item">
          <div class="menu">
            <a class="nav-link" href="#"
              [routerLink]="['information']"
              routerLinkActive
              #informationLink="routerLinkActive"
              [ngClass]='{"selected": informationLink.isActive}'>
              <span translate>menu.navigation.communicationChannel.information</span>
            </a>
          </div>
        </li>
      }
      @if (communicationChannelConfigService.isCommunicationChannelSurveyEnabled()) {
        <li class="nav-item">
          <div class="menu">
            <a class="nav-link" href="#"
              [routerLink]="['surveys']"
              routerLinkActive
              #surveyLink="routerLinkActive"
              [ngClass]='{"selected": surveyLink.isActive}'>
              <span translate>menu.navigation.communicationChannel.surveys</span>
            </a>
          </div>
        </li>
      }
      @if (communicationChannelConfigService.isCommunicationChannelContactEnabled()) {
        <li class="nav-item">
          <div class="menu">
            <a class="nav-link" href="#"
              [routerLink]="['contact']"
              routerLinkActive
              #contactLink="routerLinkActive"
              [ngClass]='{"selected": contactLink.isActive}'>
              <span translate>menu.navigation.communicationChannel.contact</span>
            </a>
          </div>
        </li>
      }
    </ul>
  </div>
}

<router-outlet></router-outlet>
